/* eslint-disable import/prefer-default-export */
import asyncService from '../../../../datahub/asyncService';

/**
 * Service for handling worker contract API operations
 */
export class ContractApiService {
  /**
   * Creates a new worker contract
   * @param {Object} payload - The contract data payload
   * @param {Object} user - User object with token and refreshToken
   * @param {Function} dispatch - Redux dispatch function
   * @param {Function} onSuccess - Success callback
   * @param {Function} onError - Error callback
   */
  static async createContract(payload, user, dispatch, onSuccess, onError) {
    return asyncService({
      httpMethod: 'POST',
      route: 'worker-contracts/create',
      data: payload,
      onSuccess,
      onError,
      dispatch,
      token: user?.token,
      refreshToken: user?.refreshToken,
    });
  }

  /**
   * Deletes a worker contract
   * @param {string} contractId - The contract ID to delete
   * @param {Object} user - User object with token and refreshToken
   * @param {Function} dispatch - Redux dispatch function
   * @param {Function} onSuccess - Success callback
   * @param {Function} onError - Error callback
   */
  static async deleteContract(contractId, user, dispatch, onSuccess, onError) {
    return asyncService({
      httpMethod: 'POST',
      route: 'worker-contracts/delete',
      data: { workerContractId: contractId },
      onSuccess,
      onError,
      dispatch,
      token: user?.token,
      refreshToken: user?.refreshToken,
    });
  }
}
